import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { TdDialogService } from '@covalent/core';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { Piece } from '../../../inventory/piece';
import { LocationService } from 'services/location.service';
import { InventoryService } from '../../../inventory/inventory.service';
import { Response } from '@angular/http/src/static_response';
import { Branch } from '../../../accounting/branch';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';

@Component({
  selector: 'app-inv-change-location',
  templateUrl: './change-location.component.html',
  styleUrls: ['./change-location.component.scss']
})
export class InvChangeLocationComponent implements OnInit {
  title: string;
  pieceNumber: any;
  newLocation: any;

  allBranches$: Observable<Branch[]>;
  branchFilter: number = 0;

  locations: any[] = [];

  constructor(private _dialogService: TdDialogService,
    public _authService: AuthenticationService,
    private _locationService: LocationService,
    private _inventoryService: InventoryService,
    private location: Location) { }

  ngOnInit(): void {
    // Then default to user's home branch
    this.branchFilter = this._authService.getUserBranches().find(b => { return b.id == this._authService.getHomeBranch() }).id;
    //Use this user's branches instead
    //this.allBranches$ = this._salesService.getBranches();
    this.allBranches$ = Observable.of(this._authService.getUserBranches());

    this.getLocations();
  }

  goBack(): void {
    this.location.back();
  }

  /*changeLocation(): void {
    var itemFound = this.products[this.pieceNumber];
    if (!itemFound) {
      this._dialogService.openAlert({
        message: 'There is no such piece' + (this.pieceNumber ? ' ' + this.pieceNumber: '') + '!',
        title: 'Error'
      });

      return;
    }

    this._dialogService.openAlert({
      message: 'Location successfully changed!',
      title: 'Success'
    });
  }*/

  getPiece(): void {

  }

  getLocations() {
    this._locationService.getLocations(this._authService.getHomeBranch() + '').subscribe(
      response => {
        this.locations = response;
      }
    );
  }

  changeLocation(): void {
    // If location is not in the list
    if (this.locations.find((l) => { return l.name == this.newLocation }) == null) {
      this._dialogService.openAlert({
        title: 'Invalid Location',
        message: 'The location that you scanned is not registered in your home branch'
      });
      return;
    }

    this._inventoryService.changeLocation(this.pieceNumber, this.newLocation, this.branchFilter).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this._dialogService.openAlert({
            message: 'Location successfully changed!',
            title: 'Success'
          }).afterClosed().subscribe(r => this.goBack());
        } else {
          this._dialogService.openAlert({
            message: 'Could not change piece location!',
            title: 'Error'
          });
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/pda/inventory/change-location/change-location.component.ts